import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LocationQueryDto} from '../../features/startup/dtos/location-query.dto';
import {Observable} from 'rxjs';
import {LocationDetailDto} from '../../features/startup/dtos/location-detail.dto';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  http = inject(HttpClient);

  queryLocationDetails(locationQueryDto: LocationQueryDto): Observable<LocationDetailDto[]> {
    return this.http.post<LocationDetailDto[]>(`${environment.cenplexBookingApiBaseUrl}/locations/query`, locationQueryDto);
  }
}
